module.exports = __webpack_public_path__ + "static/media/4.447fb098.jpg";